const initialState = {
  disable: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'DISABLE':
      const { disable } = action;
      return {
        ...state,
        disable,
      };
    default:
      return state;
  }
};

export const setDisable = (
  disable,
) => ({
  type: 'DISABLE',
  disable,
});
